(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["p21-cart-details"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('p21-cart-details')) return;
    const records = new Map();
    const fieldSelector = '[data-cart-detail-key]';
    const checkoutSelector = 'button[name="checkout"], input[name="checkout"]';

    class P21CartDetails extends HTMLElement {
      connectedCallback() {
        this.cartForm = this.closest('form[data-cart-content]');
        if (!this.cartForm || this.connected) return;
        this.connected = true;
        const key = this.dataset.sectionId;
        if (!records.has(key)) records.set(key, { values:{}, saved:{}, edited:new Set(), dirty:new Set(), uncertain:new Set(), pending:null, timer:null, continuing:false, owner:null });
        this.record = records.get(key);
        this.record.owner = this;
        this.querySelectorAll(fieldSelector).forEach(field => {
          const name = field.dataset.cartDetailKey;
          if (this.record.edited.has(name)) field.value = this.record.values[name];
          else this.record.values[name] = this.record.saved[name] = field.value;
        });
        this.onInput = event => this.captureField(event, false);
        this.onChange = event => this.captureField(event, true);
        this.onClick = event => {
          const button = event.target.closest(checkoutSelector);
          if (button && button.form === this.cartForm) this.guardCheckout(event, button);
        };
        this.onSubmit = event => {
          const button = event.submitter || this.cartForm.querySelector(checkoutSelector);
          if (button && button.matches(checkoutSelector)) this.guardCheckout(event, button);
        };
        this.onRetry = () => this.flush().catch(() => {});
        this.addEventListener('input', this.onInput);
        this.addEventListener('change', this.onChange);
        this.cartForm.addEventListener('click', this.onClick, true);
        this.cartForm.addEventListener('submit', this.onSubmit, true);
        this.querySelector('[data-cart-detail-retry]').addEventListener('click', this.onRetry);
        if (this.record.dirty.size) this.queueSave();
      }

      disconnectedCallback() {
        if (!this.connected) return;
        this.connected = false;
        this.removeEventListener('input', this.onInput);
        this.removeEventListener('change', this.onChange);
        this.cartForm.removeEventListener('click', this.onClick, true);
        this.cartForm.removeEventListener('submit', this.onSubmit, true);
        this.querySelector('[data-cart-detail-retry]').removeEventListener('click', this.onRetry);
        if (this.record.owner === this) this.record.owner = null;
      }

      captureField(event, immediate) {
        const field = event.target;
        if (!field.matches(fieldSelector) || field.closest('p21-cart-details') !== this || field.disabled) return;
        const name = field.dataset.cartDetailKey;
        this.record.edited.add(name);
        this.record.values[name] = field.value;
        this.markDirty(name);
        if (field.id === 'myMessage' && field.value.trim()) this.setMessageError(false);
        clearTimeout(this.record.timer);
        if (immediate) this.flush().catch(() => {});
        else this.queueSave();
      }

      markDirty(name) {
        if (!this.record.uncertain.has(name) && this.record.values[name] === this.record.saved[name]) this.record.dirty.delete(name);
        else this.record.dirty.add(name);
      }

      queueSave() {
        clearTimeout(this.record.timer);
        this.record.timer = setTimeout(() => this.flush().catch(() => {}), 400);
      }

      setStatus(state) {
        const owner = this.record.owner;
        if (!owner || !owner.isConnected) return;
        const status = owner.querySelector('.p21-cart-details__save-status');
        status.hidden = false;
        status.dataset.state = state;
        owner.querySelector('[data-cart-detail-status]').textContent = state === 'error' ? owner.dataset.saveError : owner.dataset[state];
        owner.querySelector('[data-cart-detail-retry]').hidden = state !== 'error';
      }

      async save(attributes) {
        this.setStatus('saving');
        try {
          const response = await fetch(this.dataset.updateUrl, {
            method:'POST',
            credentials:'same-origin',
            headers:{'Content-Type':'application/json', 'Accept':'application/json'},
            body:JSON.stringify({attributes})
          });
          if (!response.ok) throw new Error('cart_details_save_failed');
          const cart = await response.json();
          if (!cart || !cart.attributes || typeof cart.attributes !== 'object') throw new Error('cart_details_invalid_response');
          for (const name of Object.keys(attributes)) {
            if (String(cart.attributes[name] ?? '') !== attributes[name]) throw new Error('cart_details_not_saved');
          }
          for (const name of Object.keys(attributes)) {
            this.record.saved[name] = attributes[name];
            this.record.uncertain.delete(name);
            this.markDirty(name);
          }
        } catch (error) {
          for (const name of Object.keys(attributes)) {
            this.record.uncertain.add(name);
            this.markDirty(name);
          }
          this.setStatus('error');
          throw error;
        }
      }

      async flush() {
        clearTimeout(this.record.timer);
        while (this.record.pending || this.record.dirty.size) {
          if (this.record.pending) {
            await this.record.pending;
            continue;
          }
          const attributes = {};
          for (const name of this.record.dirty) attributes[name] = this.record.values[name];
          const pending = this.save(attributes);
          this.record.pending = pending;
          try { await pending; }
          finally { if (this.record.pending === pending) this.record.pending = null; }
        }
        this.setStatus('saved');
      }

      detailsVisible() {
        return this.isConnected && !document.body.classList.contains('workshop-only-cart') && this.getClientRects().length > 0 && getComputedStyle(this).visibility !== 'hidden';
      }

      setMessageError(show) {
        const field = this.querySelector('#myMessage');
        const error = this.querySelector('#p21-card-message-error');
        error.hidden = !show;
        if (show) field.setAttribute('aria-invalid', 'true');
        else field.removeAttribute('aria-invalid');
      }

      validMessage() {
        const field = this.querySelector('#myMessage');
        const required = field.required && !field.disabled && field.getClientRects().length > 0 && getComputedStyle(field).visibility !== 'hidden';
        const valid = !required || field.value.trim().length > 0;
        this.setMessageError(!valid);
        if (!valid) field.focus();
        return valid;
      }

      buttonAvailable(button) {
        return button && !button.disabled && button.getAttribute('aria-disabled') !== 'true' && button.getClientRects().length > 0 && getComputedStyle(button).pointerEvents !== 'none';
      }

      guardCheckout(event, button) {
        if (event.defaultPrevented || !this.detailsVisible() || !this.buttonAvailable(button)) return;
        this.querySelectorAll(fieldSelector).forEach(field => {
          if (field.disabled) return;
          const name = field.dataset.cartDetailKey;
          if (this.record.values[name] !== field.value) this.record.edited.add(name);
          this.record.values[name] = field.value;
          this.markDirty(name);
        });
        const valid = this.validMessage();
        if (valid && !this.record.pending && !this.record.dirty.size && !this.record.continuing) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!valid || this.record.continuing) return;
        this.record.continuing = true;
        this.flush().then(() => {
          this.record.continuing = false;
          const owner = this.record.owner;
          if (!owner || !owner.detailsVisible() || !owner.validMessage()) return;
          const currentButton = button.isConnected && button.form === owner.cartForm ? button : owner.cartForm.querySelector(checkoutSelector);
          if (owner.buttonAvailable(currentButton)) currentButton.click();
        }).catch(() => { this.record.continuing = false; });
      }
    }

    customElements.define('p21-cart-details', P21CartDetails);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["p21-mobile-nav-accessibility"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__p21MobileNavLoaded) return;
    window.__p21MobileNavLoaded = true;

    // Expire only this theme's mobile-menu cache when this revision first loads.
    // It must run before the legacy lazy loader reads its cached menu HTML.
    try {
      const prefix = window.T4SThemeSP?.cacheNameFirst;
      const revision = `p21-mobile-nav-20260910:${window.Shopify?.theme?.id || ''}`;
      if (prefix && sessionStorage.getItem(revision) !== '1') {
        for (const key of Object.keys(sessionStorage)) {
          if (key.startsWith(prefix) && /(?:time|data)MenuT4s\d*$/.test(key)) sessionStorage.removeItem(key);
        }
        sessionStorage.setItem(revision, '1');
      }
    } catch (_) { /* Navigation still works when browser storage is unavailable. */ }

    const init = () => {
      const drawer = document.getElementById('t4s-menu-drawer');
      const config = document.querySelector('[data-p21-mobile-nav-config]');
      if (!drawer || !config || drawer.dataset.p21KeyboardReady) return;
      drawer.dataset.p21KeyboardReady = 'true';
      const closeButton = drawer.nextElementSibling?.matches('[data-drawer-close]') ? drawer.nextElementSibling : null;
      const focusableSelector = 'a[href], button, input, select, textarea, [tabindex]';
      let opener = null;
      let wasOpen = false;
      let scheduled = false;
      let submenuId = 0;
      const setAttribute = (element, name, value) => {
        if (element.getAttribute(name) !== String(value)) element.setAttribute(name, String(value));
      };
      const visible = element => element.isConnected && !element.disabled && !element.closest('[hidden], [inert]') && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
      const isOpen = () => drawer.getAttribute('aria-hidden') === 'false';
      // The close button follows the drawer in the real DOM and is the final Tab stop.
      const focusable = () => [...drawer.querySelectorAll(focusableSelector), ...(closeButton && visible(closeButton) ? [closeButton] : [])].filter(element => visible(element) && element.tabIndex >= 0);
      const focusFirst = () => (focusable()[0] || drawer).focus({preventScroll:true});
      const direct = (element, selector) => [...element.children].find(child => child.matches(selector));

      function enhanceSubmenus() {
        drawer.querySelectorAll('.t4s-menu-item-has-children').forEach(item => {
          const link = direct(item, 'a');
          const submenu = direct(item, 'ul');
          if (!link || !submenu) return;
          if (!submenu.id) {
            let id;
            do { id = `p21-mobile-submenu-${++submenuId}`; } while (document.getElementById(id));
            submenu.id = id;
          }
          const special = item.matches('.t4s-currencies, .t4s-languages, .t4s-menu-item-acount');
          let toggle = special ? link : direct(item, '[data-p21-submenu-toggle]');
          if (!toggle) {
            toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'p21-mobile-nav-toggle';
            toggle.dataset.p21SubmenuToggle = 'true';
            const titleCopy = (link.querySelector('.t4s-nav_link_txt') || link).cloneNode(true);
            titleCopy.querySelectorAll('.t4s-lb_nav_mb').forEach(badge => badge.remove());
            const title = titleCopy.textContent.trim();
            toggle.setAttribute('aria-label', config.dataset.submenuLabel.replace('[title]', title));
            item.insertBefore(toggle, submenu);
          }
          if (special) {
            setAttribute(toggle, 'role', 'button');
            toggle.dataset.p21LegacyToggle = 'true';
          } else {
            if (item.classList.contains('t4s-only_icon_false')) item.classList.remove('t4s-only_icon_false');
            if (!item.classList.contains('t4s-only_icon_true')) item.classList.add('t4s-only_icon_true');
            if (!item.classList.contains('p21-mobile-nav-item')) item.classList.add('p21-mobile-nav-item');
          }
          const expanded = item.classList.contains('is--opend');
          setAttribute(toggle, 'aria-controls', submenu.id);
          setAttribute(toggle, 'aria-expanded', expanded);
          if (submenu.hidden === expanded) submenu.hidden = !expanded;
        });
      }

      function syncHelp() {
        // The menu is fetched through /search, so use the shopper's page context.
        const sobro = /\/pages\/(?:sobro(?:-[^/]*)?|carmel-flower-delivery|fishers-flower-delivery)\/?$/.test(location.pathname);
        drawer.querySelectorAll('[data-p21-mobile-help-shop="lafayette"]').forEach(shop => { if (shop.hidden !== sobro) shop.hidden = sobro; });
      }

      function sync() {
        scheduled = false;
        enhanceSubmenus();
        syncHelp();
        const open = isOpen();
        setAttribute(drawer, 'role', 'dialog');
        setAttribute(drawer, 'aria-modal', 'true');
        setAttribute(drawer, 'aria-label', config.dataset.menuLabel);
        setAttribute(drawer, 'tabindex', '-1');
        if (drawer.inert === open) drawer.inert = !open;
        if (closeButton) {
          if (!closeButton.id) closeButton.id = 'p21-mobile-menu-close';
          setAttribute(drawer, 'aria-owns', closeButton.id);
          closeButton.tabIndex = open ? 0 : -1;
          setAttribute(closeButton, 'data-drawer-target', '#t4s-menu-drawer');
        }
        document.querySelectorAll('[data-menu-drawer]').forEach(trigger => {
          setAttribute(trigger, 'aria-controls', drawer.id);
          setAttribute(trigger, 'aria-expanded', open);
          setAttribute(trigger, 'aria-label', config.dataset.menuLabel);
        });
        if (open && !wasOpen) {
          if (!opener) opener = document.activeElement;
          focusFirst();
        } else if (!open && wasOpen) {
          if (opener && visible(opener) && !document.querySelector('.t4s-drawer[aria-hidden="false"]')) opener.focus({preventScroll:true});
          opener = null;
        }
        wasOpen = open;
      }
      const scheduleSync = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(sync);
      };

      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-menu-drawer]');
        if (trigger) opener = trigger;
      }, true);
      drawer.addEventListener('click', event => {
        const toggle = event.target.closest('[data-p21-submenu-toggle]');
        if (!toggle || !drawer.contains(toggle)) return;
        event.preventDefault();
        event.stopPropagation();
        const item = toggle.parentElement;
        const submenu = direct(item, 'ul');
        const expanded = item.classList.toggle('is--opend');
        submenu.style.display = expanded ? 'block' : 'none';
        submenu.hidden = !expanded;
        setAttribute(toggle, 'aria-expanded', expanded);
      }, true);
      document.addEventListener('keydown', event => {
        if (!isOpen()) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          if (closeButton) closeButton.click();
          else window.T4SThemeSP?.Drawer?.close(event);
          return;
        }
        if (event.key === ' ' && event.target.matches('[data-p21-legacy-toggle]')) {
          event.preventDefault();
          event.target.click();
          return;
        }
        if (event.key !== 'Tab') return;
        const targets = focusable();
        const first = targets[0] || drawer;
        const last = targets[targets.length - 1] || drawer;
        if (event.shiftKey && (document.activeElement === first || !targets.includes(document.activeElement))) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !targets.includes(document.activeElement))) {
          event.preventDefault(); first.focus();
        }
      }, true);
      const observer = new MutationObserver(scheduleSync);
      observer.observe(drawer, {childList:true, subtree:true, attributes:true, attributeFilter:['aria-hidden', 'class']});
      window.addEventListener('pageshow', scheduleSync);
      document.addEventListener('shopify:section:load', scheduleSync);
      sync();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["p21-signature-purchase-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('p21-signature-purchase-options')) {
    customElements.define('p21-signature-purchase-options', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.form = this.closest('form');
        this.select = this.querySelector('[data-selling-plan]');
        const data = this.querySelector('[data-purchase-data]');
        if (!this.form || !this.select || !data) return;
        try { this.variants = JSON.parse(data.textContent); } catch { return; }
        this.abort = new AbortController();
        this.radios = [...this.querySelectorAll('[data-purchase-mode]')];
        this.planId = this.select.value;
        this.mode = this.planId ? 'subscription' : 'one-time';
        this.form.addEventListener('change', event => {
          if (event.target.matches('[name="id"]')) this.updateVariant();
          else if (this.contains(event.target) && event.target.matches('[data-purchase-mode]')) {
            this.mode = event.target.value;
            this.updateChoice(true);
          } else if (event.target === this.select) {
            this.planId = this.select.value;
            this.mode = this.planId ? 'subscription' : 'one-time';
            this.updateChoice(true);
          }
        }, { signal: this.abort.signal });
        this.form.addEventListener('reset', () => queueMicrotask(() => {
          this.mode = 'one-time';
          this.planId = '';
          this.updateVariant();
        }), { signal: this.abort.signal });
        this.form.addEventListener('formdata', event => {
          event.formData.delete(this.radios[0].name);
        }, { signal: this.abort.signal });
        this.querySelector('[data-purchase-choices]').hidden = false;
        this.querySelector('[data-fallback-label]').hidden = true;
        this.querySelector('[data-frequency-label]').hidden = false;
        this.updateVariant();
        queueMicrotask(() => this.updateChoice(false));
        customElements.whenDefined('p21-signature-product').then(() => {
          if (this.isConnected) this.updateChoice(false);
        });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
      }
      updateVariant() {
        const variantId = this.form.querySelector('[name="id"]')?.value || this.dataset.variantId;
        this.variant = this.variants.find(variant => String(variant.id) === String(variantId));
        if (!this.variant) return;
        const plans = this.variant.plans;
        this.hidden = !plans.length && !this.variant.required;
        const previous = this.planId;
        this.select.replaceChildren();
        if (!this.variant.required) {
          const oneTime = new Option(this.dataset.oneTimeLabel, '');
          oneTime.hidden = true;
          this.select.add(oneTime);
        }
        plans.forEach(plan => this.select.add(new Option(plan.name, String(plan.id))));
        this.planId = plans.some(plan => String(plan.id) === previous) ? previous : String(plans[0]?.id || '');
        if (this.variant.required && plans.length) this.mode = 'subscription';
        else if (!plans.length) this.mode = 'one-time';
        this.querySelector('[data-one-time-choice]').hidden = this.variant.required;
        this.radios[0].disabled = this.variant.required || !this.variant.available;
        this.radios[1].disabled = !plans.length || !this.variant.available;
        this.querySelector('[data-one-time-price]').textContent = this.variant.price;
        this.updateChoice(false);
      }
      updateChoice(announce) {
        if (!this.variant) return;
        const plan = this.variant.plans.find(item => String(item.id) === this.planId);
        const subscribed = this.mode === 'subscription' && Boolean(plan);
        this.select.value = subscribed ? this.planId : '';
        this.select.required = this.variant.required || subscribed;
        this.querySelector('[data-purchase-frequency]').hidden = !subscribed;
        this.radios.forEach(radio => { radio.checked = radio.value === (subscribed ? 'subscription' : 'one-time'); });
        this.querySelector('[data-subscription-price]').textContent = plan?.price || '';
        const saving = this.querySelector('[data-purchase-saving]');
        saving.textContent = plan?.saving || '';
        saving.hidden = !plan?.saving;
        this.querySelector('[data-delivery-price]').textContent = subscribed ? plan.deliveryLabel : '';
        const price = subscribed ? plan.price : this.variant.price;
        const productElement = this.closest('p21-signature-product');
        const priceElement = productElement?.querySelector('[data-product-price]');
        if (priceElement) priceElement.textContent = price;
        if (announce) this.querySelector('[data-purchase-status]').textContent = subscribed ? plan.name + ', ' + plan.deliveryLabel : this.dataset.oneTimeLabel + ', ' + price;
        this.dispatchEvent(new CustomEvent('p21:purchase-change', {
          bubbles: true,
          detail: { variantId: this.variant.id, sellingPlanId: subscribed ? plan.id : null, price }
        }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
